import * as React from 'react'
import Payment,
{
    getPaymentStatusText,
    getPaymentSourceText,
    getPaymentTypeText,
    PaymentType,
    PaymentSource, getPaymentStatusClass
} from '../../../Model/Payment'
import DateTimeHelper from '../../../Helpers/DateTimeHelper'
import { Col, Row } from 'react-bootstrap'
import { inject } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'

export interface IPaymentViewProps {
    payment: Payment
    className?: string
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
export default class PaymentView extends React.Component<IPaymentViewProps> {
    render() {
        const { payment, className, localizationStore } = this.props

        return (
            <Row className={className + ' p-0'}>
                <Col xs={12} sm={6} md={6} lg={6}>
                    {DateTimeHelper.formatDateForList(payment.createDate)}
                </Col>
                <Col xs={12} sm={6} md={6} lg={6} className="text-right">
                    <span>{payment.amount} (AZN)</span>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                    <small>
                        {localizationStore!.t('status')}: &nbsp;
                        <span className={getPaymentStatusClass(payment.paymentStatus)}>
                            {getPaymentStatusText(payment.paymentStatus)}
                        </span>&nbsp;
                    </small>

                    <small
                        hidden={!payment.paymentSource || payment.paymentSource === PaymentSource.None}
                    >
                        {localizationStore!.t('paymentSource')}: {getPaymentSourceText(payment.paymentSource)}&nbsp;
                    </small>

                    <small
                        hidden={!payment.paymentType || payment.paymentType === PaymentType.None}
                    >
                        {localizationStore!.t('paymentType')}: {getPaymentTypeText(payment.paymentType)}&nbsp;
                    </small>

                    <small>
                        {localizationStore!.t('paymentDateTime')}:&nbsp;
                        {DateTimeHelper.formatDateForList(payment.paymentDateTime)}&nbsp;
                    </small>

                    <small>{localizationStore!.t('description')}: {payment.description}</small>
                </Col>
            </Row>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Payment/PaymentView.tsx